export default "__VITE_ASSET__DChqXqpr__"